<mat-card class='p-24 mat-elevation-z0'>
	<mat-card-content>
		<data-container-viewer 
			[dataContainerService]='datACS' 
			[fields]='formConfig.fields' 
			[record]='record'
		></data-container-viewer>
	</mat-card-content>
	<mat-card-actions [align]="'end'" *ngIf='showActions'>
		<button *ngIf='canEdit' (click)='onEdit()' mat-flat-button color='accent'>{{'Modifica' | translate}}</button>
	</mat-card-actions>
</mat-card>